import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';
import Constant from '../common/Constant';

const DEFAULT_STATE = Immutable({
  uid: '',
  email: '',
  companyName: '',
  companyImageURL: '',
  defaultCurrency: Constant.DEFAULT_CURRENCY_CODE,
});

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.USER_LOGGED_IN:
    case ActionTypes.USER_SETTINGS_UPDATED:
      return state.merge(action.user);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js